import { ISupplierDetailsResponse } from "~/types/supplier.interface";
import URlS from "~/api/urls";

export async function getGetSupplierDetails(
  supplierId: string,
  subscriptionModel: number
): Promise<ISupplierDetailsResponse> {
  const url = URlS.supplierV2.details(supplierId, subscriptionModel);
  const res = await $fetch(url, {
    method: "GET",
  });
  return res as ISupplierDetailsResponse;
}
